/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReverseEnteralNutritionAliases {
  AUTOCOMPLETE_REASON_LIST = 'autocomplete-reason-list',
  CONTEXTUAL_BAR_REVERSE_ENTERAL_NUTRITION = 'contextual-bar-reverse-enteral-nutrition',
  FETCH_REASON = 'fetch-reason',
  FIELD_REASON = 'field-reason',
  FORM_REASON = 'form-reason',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  HEADER_FRAGMENT_REVERSE_ENTERAL_NUTRITION = 'header-fragment-reverse-enteral-nutrition',
  MAPPER_REVERSE = 'mapper-reverse',
  PANEL_HEADER = 'panel-header',
  PANEL_REVERSE_ENTERAL_NUTRITION = 'panel-reverse-enteral-nutrition',
  REVERSE_ENTERAL_NUTRITION_LAYOUT = 'reverse-enteral-nutrition-layout',
  TEXT_REVERSE = 'text-reverse',
}
export { ReverseEnteralNutritionAliases };
